export function heroOverhangListener(){

    const overhangCheck = document.getElementsByClassName("hero-with-image-overhang");

    if(overhangCheck[0] != null){
        document.body.classList.add('has-hero-with-image-overhang');
    }
}